// 文件已弃用，请使用 firebase.js
// 重新导出firebase.js中的内容以保持兼容性
import { app, db, auth, storage } from './firebase';

// 添加一个伪analytics对象以避免导入错误
const analytics = {
  logEvent: () => {},
  setCurrentScreen: () => {},
  setUserId: () => {}
};

export { app, analytics, auth, db, storage };